var _rect, _polygon, _path, _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorWasteBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.386,
    y: 8.711,
    width: 27.228,
    height: 4.538
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "30.27 38.765 11.73 38.765 9.58 13.249 32.42 13.249 30.27 38.765"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m27.309,8.711c-.433-3.072-3.074-5.476-6.257-5.476s-5.823,2.401-6.256,5.476"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 21.279,
    x2: 21,
    y2: 33.938
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 15.808,
    y1: 21.279,
    x2: 16.475,
    y2: 33.938
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 26.192,
    y1: 21.279,
    x2: 25.525,
    y2: 33.938
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorWasteBasket);
export default __webpack_public_path__ + "static/media/indoor-waste_basket.b69b5acefe7f2675671fc601252a7d25.svg";
export { ForwardRef as ReactComponent };